import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5fe34642"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title" }, "Организация", -1))
const _hoisted_4 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Наименование организации", -1))
const _hoisted_6 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Описание организации", -1))
const _hoisted_8 = { class: "flex flex-col fl-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Tenant", -1))
const _hoisted_10 = { class: "toggle-row m-t-10" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "is_demo",
  class: "small-label"
}, "Демо-организация", -1))
const _hoisted_12 = { class: "flex fl-jc-sb flex-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title" }, "Департамент", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash f-s-12" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Наименование департамента", -1))
const _hoisted_22 = { class: "sub-block" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title" }, "Должности", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Наименование должности", -1))
const _hoisted_25 = { class: "flex flex-center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash f-s-12" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]

import { ref, watch, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useOrganizationsStore } from "@/store/dictionaries/organizations";

import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";

import { areOrganizationFieldsValid } from "@/services/dictionaries/organizations";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationCreateForm',
  emits: ["setLoading"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const route = useRoute();
const router = useRouter();
const store = useOrganizationsStore();

const organization = ref({
  name: "",
  description: "",
  tenant: "",
  is_demo: false,
  departments: [
    {
      name: "",
      description: "",
      roles: [
        {
          name: "",
          description: "",
        },
      ],
    },
  ],
});

const isInvalidForm = ref(false);
const isOrganizationSetted = computed(() => {
  return Boolean(route.params.id);
});

const reload = () => {
  if (isOrganizationSetted.value) {
    const organizationId = parseInt(route.params.id);
    store.getOrganization(organizationId).then((organizationClone) => {
      if (organizationClone) {
        organization.value = organizationClone;
      }
    });
  }
};

onMounted(() => {
  reload();
});

const addDepartment = (idx: number) => {
  organization.value.departments.splice(idx + 1, 0, {
    name: "",
    description: "",
    roles: [
      {
        name: "",
        description: "",
      },
    ],
  });
};

const deleteDepartment = (idx: number) => {
  organization.value.departments.splice(idx, 1);
};

const addRole = (idxDep: number, idxRole: number) => {
  organization.value.departments[idxDep].roles.splice(idxRole + 1, 0, {
    name: "",
    description: "",
  });
};

const deleteRole = (idxDep: number, idxRole: number) => {
  organization.value.departments[idxDep].roles.splice(idxRole, 1);
};

const createOrganization = () => {
  if (!areOrganizationFieldsValid(organization.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`
    );
    return;
  }
  emit("setLoading", true);
  const orgForCreate = {
    organization: {
      name: organization.value.name,
      description: organization.value.description,
      tenant: organization.value.tenant,
      is_demo: organization.value.is_demo,
    },
    departments: organization.value.departments,
  };

  if (!isOrganizationSetted.value) {
    performOrganizationAction(() => store.createOrganization(orgForCreate));
  } else {
    performOrganizationAction(() =>
      store.updateOrganization(orgForCreate, parseInt(route.params.id))
    );
  }
};

const performOrganizationAction = (action: any) => {
  const handleCampaignSuccess = () => {
    router.push({ name: "listOrganizations" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  action()
    .then(handleCampaignSuccess)
    .catch((err: any) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      if (err.response && err.response.status == 403)
        rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
    })
    .finally(() => {
      emit("setLoading", false);
    });
};

__expose({
  createOrganization,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_unref(InputText), {
          id: "name",
          placeholder: "Введите значение",
          modelValue: organization.value.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organization.value.name) = $event)),
          invalid: isInvalidForm.value && organization.value.name == ''
        }, null, 8, ["modelValue", "invalid"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_unref(InputText), {
          id: "name",
          placeholder: "Введите значение",
          modelValue: organization.value.description,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((organization.value.description) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_unref(InputText), {
          id: "name",
          placeholder: "Введите значение",
          modelValue: organization.value.tenant,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((organization.value.tenant) = $event)),
          invalid: isInvalidForm.value && organization.value.tenant == ''
        }, null, 8, ["modelValue", "invalid"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_unref(InputSwitch), {
          modelValue: organization.value.is_demo,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((organization.value.is_demo) = $event)),
          inputId: "is_demo"
        }, null, 8, ["modelValue"])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organization.value.departments, (department, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "form-block",
        key: `dep-${idx}`
      }, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", {
            class: _normalizeClass(["group-button-container dep flex", [idx != organization.value.departments.length - 1 ? 'hidden' : '']])
          }, [
            (organization.value.departments.length > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "delete-button flex flex-center",
                  onClick: ($event: any) => (deleteDepartment(idx))
                }, _hoisted_16, 8, _hoisted_14))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "add-button flex flex-center",
              onClick: ($event: any) => (addDepartment(idx))
            }, _hoisted_19, 8, _hoisted_17)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_unref(InputText), {
            id: "name",
            placeholder: "Введите значение",
            modelValue: department.name,
            "onUpdate:modelValue": ($event: any) => ((department.name) = $event),
            invalid: isInvalidForm.value && department.name == ''
          }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(department.roles, (role, idxr) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex flex-col fl-1 m-b-8 role-container",
              key: `role-${idxr}`
            }, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_unref(InputText), {
                  id: "name",
                  class: "fl-1",
                  placeholder: "Введите значение",
                  modelValue: role.name,
                  "onUpdate:modelValue": ($event: any) => ((role.name) = $event),
                  invalid: isInvalidForm.value && role.name == ''
                }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"]),
                _createElementVNode("div", {
                  class: _normalizeClass(["group-button-container role flex m-l-8", [
                idxr != organization.value.departments[idx].roles.length - 1
                  ? 'hidden'
                  : '',
              ]])
                }, [
                  (organization.value.departments[idx].roles.length > 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "delete-button flex flex-center",
                        onClick: ($event: any) => (deleteRole(idx, idxr))
                      }, _hoisted_28, 8, _hoisted_26))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "add-button flex flex-center",
                    onClick: ($event: any) => (addRole(idx, idxr))
                  }, _hoisted_31, 8, _hoisted_29)
                ], 2)
              ])
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})